import script from "./PopupWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupWindow.vue?vue&type=script&setup=true&lang=js"

import "./PopupWindow.vue?vue&type=style&index=0&id=6ea2fd73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea2fd73"]])

export default __exports__